import { MarketId } from 'types/market-id.enum';

export enum ContactType {
  cargillContact = 'cargillContact',
  marketContact = 'marketContact',
}

export interface Contact {
  id: string;
  marketId: MarketId;
  name: string;
  email: string;
  phone: string;
  contactType: ContactType;
}
